module Tapas.Bindings {
    export class FocusFirstInputOnClick {
        public init(element: any, valueAccessor: () => any, allBindingsAccessor?: KnockoutAllBindingsAccessor, viewModel?: any, bindingContext?: KnockoutBindingContext) {
            if (!bindingContext)
                return;

            ko.utils.registerEventHandler(element, "click", (e) => {
				if (element == e.target) {
					$(element).find("input[type='text']").first().focus();
				}
            });
        }
    }
    ko.bindingHandlers['focusFirstInputOnClick'] = new FocusFirstInputOnClick();
} 
